import { render, staticRenderFns } from "./Advice.vue?vue&type=template&id=53a72d1e&scoped=true&"
var script = {}
import style0 from "./Advice.vue?vue&type=style&index=0&id=53a72d1e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a72d1e",
  null
  
)

export default component.exports